module.exports = __webpack_public_path__ + "img/smart-home.b94256e4.jpg";